import { render } from "./AddUserModal.vue?vue&type=template&id=38a4a335"
import script from "./AddUserModal.vue?vue&type=script&lang=js"
export * from "./AddUserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/settings/settings-modals/AddUserModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38a4a335"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38a4a335', __exports__)) {
    api.reload('38a4a335', __exports__)
  }
  
  module.hot.accept("./AddUserModal.vue?vue&type=template&id=38a4a335", () => {
    api.rerender('38a4a335', render)
  })

}


export default __exports__